export default {
    SET_LOGIN: 'SET_LOGIN',
    RESET_LOGIN: 'RESET_LOGIN',
    TOGGLE_PAGE_LOADER:'TOGGLE_PAGE_LOADER'
  };
  